<template>
  <v-toolbar-items>
    <v-btn
      tile
      small
      class=" main-menu px-0 mr-3"
      text
      :ripple="false"
      v-for="(link, index) in subNavigationLinks"
      :key="index"
      :to="link.link"
      :data-test-id="link.meta && link.meta.id"
    >
      {{ link.title }}
    </v-btn>
  </v-toolbar-items>
</template>

<script>
export default {
  data() {
    return {
      subNavigationLinks: [
        {
          title: 'Current',
          link: '/discovery/overview/current',
          meta: {
            id: 'discovery__current-tab'
          }
        },
        {
          title: 'Archived',
          link: '/discovery/overview/archived',
          meta: {
            id: 'discovery__archived-tab'
          }
        }
      ]
    };
  }
};
</script>
